export const apiConfigs = {
    baseURL : "https://sooraj.ir/v1/",
};
